module.exports = __webpack_public_path__ + "static/img/indd.a63eec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/indd.png
// module id = yJbU
// module chunks = 53